var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockDetailsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 34V23.999M24 23.999L14.3223 18.9985M24 23.999L33.6778 18.9985M19 16.2678L29 21.4183M22.8889 33.7299C23.2267 33.9054 23.6099 33.9979 24 33.9979C24.3901 33.9979 24.7733 33.9054 25.1111 33.7299L32.8889 29.7295C33.2264 29.5541 33.5067 29.3019 33.7017 28.9982C33.8967 28.6946 33.9996 28.3501 34 27.9993V19.9985C33.9996 19.6478 33.8967 19.3033 33.7017 18.9996C33.5067 18.6959 33.2264 18.4437 32.8889 18.2684L25.1111 14.268C24.7733 14.0924 24.3901 14 24 14C23.6099 14 23.2267 14.0924 22.8889 14.268L15.1111 18.2684C14.7736 18.4437 14.4933 18.6959 14.2983 18.9996C14.1033 19.3033 14.0004 19.6478 14 19.9985V27.9993C14.0004 28.3501 14.1033 28.6946 14.2983 28.9982C14.4933 29.3019 14.7736 29.5541 15.1111 29.7295L22.8889 33.7299Z",
    stroke: "#CC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockDetailsActive);
export default __webpack_public_path__ + "static/media/stock-details-active.38af310f23f2aa8f5e7d962cdd4f2d67.svg";
export { ForwardRef as ReactComponent };